import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9add661a")

_pushScopeId("data-v-9add661a")
const _hoisted_1 = { class: "main-bg" }
const _hoisted_2 = { class: "layer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_c_search_list = _resolveComponent("c-search-list")
  const _component_el_button = _resolveComponent("el-button")
  const _component_c_button_group = _resolveComponent("c-button-group")
  const _component_c_table = _resolveComponent("c-table")
  const _component_detail = _resolveComponent("detail")
  const _directive_hasAuth = _resolveDirective("hasAuth")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_c_search_list, {
      inputList: _ctx.inputList,
      spreadStatus: false,
      onOnSearch: _ctx.handleSearch,
      onOnReset: _ctx.handleReset
    }, null, 8, ["inputList", "onOnSearch", "onOnReset"]), [
      [_directive_hasAuth, 'new-deduction-record-query']
    ]),
    _createVNode("div", _hoisted_2, [
      _createVNode("span", null, "查询结果：车辆使用费 成功合计：" + _toDisplayString(_ctx.sumDate.carUsageFeeSuccess || '0') + " 元 失败合计：" + _toDisplayString(_ctx.sumDate.carUsageFeeError || '0') + " 元 ", 1)
    ]),
    _createVNode(_component_c_table, {
      dataSource: _ctx.tableConfig,
      isIndex: true,
      onPageCurrentChange: _ctx.pageCurrentChange,
      onPageSizeChange: _ctx.pageSizeChange
    }, {
      action: _withId((scope) => [
        _createVNode(_component_c_button_group, {
          key: new Date().getTime(),
          len: 3
        }, {
          default: _withId(() => [
            _withDirectives(_createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: ($event: any) => (_ctx.look(scope.row))
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.btnName('new-deduction-record-detail') || '详情'), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]), [
              [_directive_hasAuth, 'new-deduction-record-detail']
            ])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["dataSource", "onPageCurrentChange", "onPageSizeChange"]),
    (_ctx.visible)
      ? (_openBlock(), _createBlock(_component_detail, {
          key: 0,
          rowData: _ctx.rowData,
          visible: _ctx.visible,
          "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = $event))
        }, null, 8, ["rowData", "visible"]))
      : _createCommentVNode("", true)
  ]))
})